import BdkAccordion from '@breuni-ui/bdk-accordion';
import { safeDefine } from '@breuni-ui/safe-define';

export class EntsAccordion extends BdkAccordion {}

safeDefine('ents-accordion', EntsAccordion);
